export const MOIS = ["JANVIER", "FÉVRIER", "MARS", "AVRIL", "MAI", "JUIN", "JUILLET", "AOÛT", "SEPTEMBRE", "OCTOBRE", "NOVEMBRE", "DÉCEMBRE"];

export const formatDateRange = (debut, fin) => {
  const d1 = new Date(debut);
  const d2 = new Date(fin);
  if (Number.isNaN(d1) || Number.isNaN(d2)) return "";
  if (d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()) {
    return `${d1.getDate()} → ${d2.getDate()} ${MOIS[d1.getMonth()]} ${d1.getFullYear()}`;
  }
  return `${d1.getDate()} ${MOIS[d1.getMonth()]} → ${d2.getDate()} ${MOIS[d2.getMonth()]} ${d2.getFullYear()}`;
};

export const formatDateFR = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d) ? "" : d.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
};

export const CATEGORY_ORDER = Array.from({ length: 13 }, (_, i) => `U${i + 6}`);

export const categoryLabel = (cats = []) => {
  const idx = cats.map((c) => CATEGORY_ORDER.indexOf(c)).filter((i) => i >= 0).sort((a, b) => a - b);
  if (!idx.length) return "";
  const contiguous = idx.every((v, i) => i === 0 || v === idx[i - 1] + 1);
  if (contiguous && idx.length > 1) return `${CATEGORY_ORDER[idx[0]]} → ${CATEGORY_ORDER[idx[idx.length - 1]]}`;
  return idx.map((i) => CATEGORY_ORDER[i]).join(" · ");
};

export const formatPrice = (price) =>
  `${new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Math.round(price || 0))} €`;

export const stageBasePath = (stage) =>
  stage?.stage_type === "stage_pro_semi_pro" ? "/stage-pro" : "/stage-payet";

export const stageTypeLabel = (stage) =>
  stage?.stage_type === "stage_pro_semi_pro" ? "Stage Pro / Semi-Pro" : "Stage Payet";
